// 개인정보 처리위탁 계약서 — 계약서 판·주소와 기존 업체 동의 콜러블(acceptDpa). 판은 서버 functions/src/dpaConsent.ts와 같아야 한다
import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export const DPA_VERSION = "2026-10-31c";
export const DPA_URL = "https://freemilkkok.com/dpa";

const _accept = httpsCallable<{ version: string; agreed: boolean }, { ok: boolean; already: boolean; version: string }>(functions, "acceptDpa");

/** 대표 계정이 지금 판 계약서에 동의 — 서버가 시각·계정을 적는다 */
export async function acceptDpa() {
  return (await _accept({ version: DPA_VERSION, agreed: true })).data;
}
